{
  "prescans": {
    "titles": {
      "step1": "Stap 1 - Bedrijfsnaam klant",
      "step2": "Stap 2 - Alle bankbestanden (MT940) van afgelopen 12 maanden uploaden",
      "step3": "Stap 3 - Financiële gegevens onderneming",
      "step4": "Stap 4 - Know Your Client (KYC)",
      "step5": "Stap 5 - Informatie t.b.v. beoordelen zekerheden en financiële positie",
      "step6": "Stap 6 - Relatiebeheer"
    }
  },
  "titles": {
    "menu": "Pre-Scan indienen",
    "view": "Pre-Scan indienen",
    "dialog": "Welkom bij DebitRoom Pre-Scan",
    "kycDialog": "Informatie ondernemer",
    "savedPreScans": "Opgeslagen Pre-Scans",
    "confirmationDialog": "Pre-Scan (concept) verwijderen?",
    "findCompany": "Klant zoeken",
    "step1": "Bedrijfsnaam klant",
    "step2": "Alle bankbestanden (MT940) van afgelopen 12 maanden uploaden",
    "step3": "Financiële gegevens onderneming",
    "step5": "Know Your Client (KYC)",
    "step8": "Informatie t.b.v. beoordelen zekerheden en financiële positie",
    "step9": "Relatiebeheer",
    "emailOption": "Wat is de reden voor het aanvullen van de prescan?",
    "stepEmail": "Wat is de reden voor het aanvullen van de preScan?",
    "FinanceDataTwoYearsAgo": "Financiële (voorlopige) cijfers {year}",
    "FinanceDataLastYear": "Financiële (voorlopige) cijfers {year}",
    "FinanceDataCurrentYear": "Financiële (voorlopige) cijfers {year}",
    "Season": "Is er sprake van seizoensinvloeden op de omzet of kosten?",
    "DesiredLimit": "Wat is de gewenste DebitRoom rekening-courant limiet?",
    "CreditNeeded": "Wat is de werkelijke kredietbehoefte op korte termijn?",
    "Reason": "Wat is de reden van de aanvraag? Indien herfinanciering, graag specifiek benoemen",
    "Length": "Hoe lang verwacht je dat het DebitRoom rekening-courant krediet nodig is?",
    "kyc": {
      "history": "Hoe lang ken je de ondernemer persoonlijk?",
      "checksDone": "Is er een KYC (ken je klant) onderzoek conform Wwft anti-witwas voor deze ondernemer uitgevoerd?",
      "names": "Wat is/zijn de namen van de UBO/UBO’s?",
      "emailAddresses": "Wat is/zijn de e-mailadressen van de UBO/UBO's?",
      "organization": "Indien er sprake is van een groep, voeg dan een actueel organogram toe:",
      "website": "Wat is de website van de ondernemer?"
    },
    "confirmSavingDraft": "Pre-Scan tussentijds opgeslagen",
    "confirmSaving": "Pre-Scan opgestuurd!"
  },
  "placeholders": {
    "companySearch": "Zoek op naam of op een KvK nummer"
  },
  "messages": {
    "noSubmittedPrescans": "Er zijn geen concept Pre-Scans",
    "confirmationDialog": "Weet je zeker dat je de Pre-Scan voor {name} wilt verwijderen?",
    "preScanDeleted": "De Pre-Scan is verwijderd.",
    "preScanDraftSubmitted": "De Pre-Scan is tussentijds opgeslagen en wordt verwerkt.",
    "intro": "Om voor een klant een Pre-Scan aan te vragen dien je de volgende gegevens bij de hand te hebben:\n\n- Bedrijfsnaam of KvK inschrijfnummer\n- MT940 bestanden van de afgelopen 12 maanden (maximaal 7 dagen oud)\n- Jaarrekening van afgelopen jaar\n- Gerealiseerde- en verwachte omzet huidig jaar\n- Gewenst rekening-courant krediet bij DebitRoom\n- Informatie m.b.t. eventuele overheidssteun\n- Huidige financiële gegevens onderneming\n- Meest recente IB-aangifte van de ondernemer(s)",
    "filesUploaded": "{qty} bestanden geüpload",
    "uploadFilesIntro": "De te uploaden bankbestanden mogen van de volgende types zijn: .sta .swi .940 .mt940 .txt .dat. Daarnaast moeten alle bestanden samen aan de volgende eisen voldoen:",
    "fieldsRequiredForPreScan": "Om tot eventuele acceptatie over te kunnen gaan is beantwoording van onderstaande vragen benodigd.",
    "fileChecks": {
      "gaps": "Alle bankbestanden moeten m.b.t. de datums aan elkaar aansluiten of overlappen, gaten worden niet geaccepteerd.",
      "weekOld": "De laatste datum van de bestanden mag maximaal één week oud zijn.",
      "twelveMonths": "De bestanden moeten minimaal 12 maanden bevatten."
    },
    "uploadFilesValidation": "Om de huidig gekozen bestanden te valideren, moet je op de knop 'Bestanden controleren' klikken. Indien de knop niet actief is, moet je of extra bestanden toevoegen, of bestanden weghalen om de knop weer te activeren.",
    "uploadExtraFiles": "Extra bankbestanden kunnen worden hieronder worden geüpload. Vergeet na het accepteren van de bestanden de Pre-Scan niet opnieuw (tussentijds) op te slaan.",
    "companyExists": "De gekozen klant bestaat al",
    "confirmSavingDraft": "Bedankt voor het tussentijds opslaan van de Pre-Scan voor {name}. De Pre-Scan is opgeslagen en deze kan later afgerond worden. Wanneer de Pre-Scan is ingediend, zal deze in behandeling worden genomen.",
    "confirmSaving": "Bedankt voor het indienen van de Pre-Scan voor {name} gevestigd te {address}. Wij zullen zo spoedig mogelijk laten weten wat de resultaten zijn van de aanvraag. Indien er nog vragen vanuit ons zijn om de aanvraag te voltooien, nemen we zo snel mogelijk contact met je op.",
    "uploadedDocuments": "{0} geselecteerde bestanden",
    "existingUploads": "Eerder toegevoegde bestanden"
  },
  "actions": {
    "findCompany": "Klant zoeken",
    "addPreScan": "Pre-Scan indienen",
    "supplementPrescan": "Pre-Scan aanvullen",
    "checkFiles": "Bestanden controleren",
    "uploadFiles": "Bestanden uploaden",
    "acceptFiles": "Bestanden accepteren",
    "enterDataAboutBusiness": "Vul vragen over de onderneming in",
    "enterDataAboutBusinessOwner": "Vul vragen over de ondernemer in",
    "enterDataAboutFinancialPosition": "Vul vragen over de zekerheden in",
    "nextStep": "Volgende stap",
    "saveDraft": "Tussentijds opslaan",
    "save": "Pre-Scan indienen"
  },
  "fields": {
    "placeholders": {
      "step6b": "Vul hier de reden in (maximaal 250 tekens)",
      "step8": "Vul hier de reden in voor de kredietaanvraag (maximaal 250 tekens)"
    },
    "labels": {
      "step1Question1": "Jaaromzet {year}",
      "step1Question2": "Eigen vermogen 31-12-{year}",
      "step1Question3": "Resultaat na belasting {year}",
      "step2Question1": "Jaaromzet {year}",
      "step2Question2": "Eigen vermogen 31-12-{year}",
      "step2Question3": "Resultaat na belasting {year}",
      "step3Question1a": "Jaaromzet gerealiseerd",
      "step3Question1b": "Bedrag",
      "step3Question2": "Verwachte jaaromzet {year}",
      "step3Question3": "Verwacht resultaat {year} voor belasting",
      "worse": "Slechter dan vorig jaar",
      "same": "Hetzelfde als vorig jaar",
      "better": "Beter dan vorig jaar",
      "unknown": "Onbekend",
      "step6b": "Toelichting",
      "lessThan10k": "≤ 10.000 euro",
      "lessThan25k": "≤ 25.000 euro",
      "lessThan50k": "≤ 50.000 euro",
      "lessThan100k": "≤ 100.000 euro",
      "lessThan250k": "≤ 250.000 euro",
      "moreThan250k": "> 250.000 euro",
      "step11": "Kredietbehoefte",
      "step8": "Reden kredietaanvraag",
      "lessThan3Months": "≤ 3 maanden",
      "lessThan6Months": "≤ 6 maanden",
      "lessThan12Months": "≤ 12 maanden",
      "indefinite": "Blijvend over beschikken",
      "reapplication": "Heraanvraag van financiering",
      "creditIncrease": "Verhoging van krediet",
      "newLoan": "Updaten van gegevens t.b.v nieuwe lening",
      "generic": "Regulier updaten van gegevens",
      "headOffice": "(Hoofdkantoor)"
    }
  },
  "kyc": {
    "fields": {
      "placeholders": {
        "step2b": "Vul hier de reden in (maximaal 250 tekens)"
      },
      "labels": {
        "step2a": "Onderzoek uitgevoerd",
        "yesPositive": "Ja, positief",
        "yesNotConclusive": "Ja, niet eenduidig positief",
        "no": "Niet uitgevoerd",
        "unknown": "Onbekend",
        "step2b": "Toelichting",
        "step8": "Namen",
        "step10": "E-mailadressen",
        "step9a": "Is er sprake van een groep?",
        "step9b": "Organogram",
        "step7": "URL van de website"
      }
    }
  },
  "financialPosition": {
    "titles": {
      "ColumnBalance": "Upload de meest recente kolommenbalans (niet ouder dan één week)",
      "DebtorsList": "Upload de actuele openstaande debiteurenlijst",
      "CreditorsList": "Upload de actuele openstaande crediteurenlijst",
      "StockList": "Upload een actueel overzicht van de voorraden",
      "IncomeTax": "Upload de IB aangifte {year} van de ondernemer(s)",
      "Mortgage": "Upload een actueel overzicht (niet ouder dan één week) met het huidig saldo resterende hypotheek van de eigen woning(en) van de ondernemer(s)",
      "GovernmentMeasures": "Zijn er overheidsmaatregelen?",
      "CurrentFinancing": "Zijn er bestaande financieringen?"
    },
    "messages": {
      "DebtorsList": "Datum van dit overzicht moet gelijk zijn met die van crediteuren",
      "CreditorsList": "Datum van dit overzicht moet gelijk zijn met die van debiteuren",
      "GovernmentMeasures": "Bijvoorbeeld: Now, uitstel belastingen etc.",
      "CurrentFinancing": "Bijvoorbeeld. factoring, rekening-courant, lang lopende lening, onderhandse lening etc. Zo ja, dan ontvangen wij graag per financiering inzicht in:\n- De hoogte van de openstaande schuld.\n- De resterende looptijd.\n- De verstrekte zekerheden."
    },
    "fields": {
      "placeholders": {
        "step2c": "Leg uit in maximaal 250 woorden, waarom deze vraag niet van toepassing is.",
        "step3c": "Leg uit in maximaal 250 woorden, waarom deze vraag niet van toepassing is."
      },
      "labels": {
        "notApplicable": "Niet van toepassing",
        "explanationNotApplicable": "Toelichting over de niet van toepassing",
        "step7b": "Wat is de hoogte van de terugbetalingsverplichting?",
        "step7c": "Wat is de looptijd van de terugbetalingsverplichting",
        "step7d": "Heeft de ondernemer tot op heden alle termijnen voldaan?",
        "step7e": "Waarom zijn niet alle termijnen voldaan?"
      }
    }
  },
  "relationManagement": {
    "fields": {
      "labels": {
        "step1": "Blijf je na de krediet aanvraag periodiek betrokken bij de onderneming voor beheer (minimaal 1x per kwartaal een update op de cijfers in de Pre-Scan)?"
      }
    }
  },
  "months": {
    "0": "t/m januari",
    "1": "t/m februari",
    "2": "t/m maart",
    "3": "t/m april",
    "4": "t/m mei",
    "5": "t/m juni",
    "6": "t/m juli",
    "7": "t/m augustus",
    "8": "t/m september",
    "9": "t/m oktober",
    "10": "t/m november",
    "11": "t/m december"
  }
}
